import styled from "styled-components";
import Icon from "../../../imagery/Icon";
import { INPUT_HEIGHT } from "../../TextInputContainer/TextInputContainer.styles";
import { resolvePaletteRoleForegroundToken } from "../../../../functions/resolvePaletteRoleForegroundToken";
import { StyledSelectProps, StyledSelectIconProps } from "../Select.types";

export const StyledSelect = styled.select<StyledSelectProps>`
	position: relative;
	height: ${INPUT_HEIGHT};
	width: 100%;
	appearance: none;
	outline: none;
	background-color: transparent;
	border: none;
	z-index: 1;
	${({ theme, colorOn, hasLabel }) => ({
		padding: `${theme.space.md} ${theme.space.xxl} ${theme.space.md} ${theme.space.md}`,
		marginTop: hasLabel ? theme.space.sm : 0,
		borderRadius: theme.radii.sm,
		color: theme.palette.hexFor(resolvePaletteRoleForegroundToken(colorOn, 1)),
	})};

	+ .Label {
		top: 0;
	}
`;

export const StyledSelectIcon = styled(Icon)<StyledSelectIconProps>`
	position: absolute;
	right: ${({ theme }) => theme.space.md};
	z-index: 1;
	transform: translateY(-50%);
	pointer-events: none;
	${({ theme, hasLabel }) => {
		return {
			top: hasLabel
				? `calc((${INPUT_HEIGHT} + ${theme.space.lg}) / 2)`
				: `calc(${INPUT_HEIGHT} / 2)`,
		};
	}}
`;
